var React = require('react');

function ArrowForward (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 6l-5 5-1.414-1.414L8.17 7H0V5h8.171L5.586 2.414 7 1l5 5z","fill":"currentColor"}));
}

ArrowForward.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = ArrowForward;

ArrowForward.default = ArrowForward;
